import { getContentfulDeliveryConfig } from './config';

const CATALOG_TYPE_IDS = [
  'competency',
  'motivation',
  'personalityDimension',
  'teamStrength',
  'salesStrength',
  'adeptAspect',
  'adeptStyle',
  'assessmentInstrument',
  'report',
].join(',');

async function fetchPages(config, locale, extraParams, signal) {
  const items = [];
  let skip = 0;
  const limit = 100;

  while (true) {
    const url = new URL(
      `${config.cdn}/spaces/${config.spaceId}/environments/${config.environment}/entries`
    );
    url.searchParams.set('access_token', config.accessToken);
    url.searchParams.set('locale', locale);
    url.searchParams.set('limit', String(limit));
    url.searchParams.set('skip', String(skip));
    url.searchParams.set('include', '0');
    Object.entries(extraParams).forEach(([key, value]) => {
      url.searchParams.set(key, value);
    });

    const response = await fetch(url.toString(), {
      signal,
      headers: { Authorization: `Bearer ${config.accessToken}` },
    });
    if (!response.ok) {
      throw new Error(`Contentful CDA ${response.status}`);
    }
    const data = await response.json();
    const page = data.items || [];
    items.push(...page);
    if (page.length === 0 || items.length >= (data.total || 0)) break;
    skip += limit;
  }

  return items;
}

export async function fetchContentfulEntries(contentfulLocale, signal) {
  const config = getContentfulDeliveryConfig();
  if (!config) return null;

  // locale=* so app/namespace (often only on en-US) are not dropped.
  // Do not use fields.app=talents here: CDA field filters ignore locale fallback,
  // so locale=de would return 0 Talents bundles and the UI would stay on local copy.
  const [copyBundles, catalogs] = await Promise.all([
    fetchPages(
      config,
      '*',
      {
        content_type: 'copyBundle',
      },
      signal
    ),
    fetchPages(
      config,
      contentfulLocale,
      {
        'sys.contentType.sys.id[in]': CATALOG_TYPE_IDS,
      },
      signal
    ),
  ]);

  return { copyBundles, catalogs };
}
